import { api } from '@/lib/api-client'

/** One row of the district HOD directory: a line department and its head. */
export interface HodDirectoryEntry {
  department: string
  hodName: string
}

interface RawHodDirectoryEntry {
  department: string
  hod_name: string
}

/**
 * District department → HOD directory (`GET /dashboard/gis/hods`, admin/super_admin only), used by the
 * Issues toolbar's HOD filter for display labels only — the filter VALUES are department names (which the
 * issues feed carries), so filtering is independent of this call; an unknown/absent department renders as
 * "HOD — {department}". Cached 30 min via `useHodDirectory`.
 */
export function getHodDirectory(): Promise<HodDirectoryEntry[]> {
  return api
    .get<RawHodDirectoryEntry[]>('/dashboard/gis/hods')
    .then((rows) => rows.map((r) => ({ department: r.department, hodName: r.hod_name })))
}
